import React, { useEffect, useState } from 'react'
import ReactSelectCreatable from 'react-select/creatable';
import toast from 'react-hot-toast';
import HttpClient from '../../utils/HttpClient';
import Loader from '../../Loader/Loader';
import { Modal, ModalHeader, ModalBody, Button, Table } from 'reactstrap';
import { FaEdit, FaEye, FaTimes } from 'react-icons/fa';

const OurExperience = () => {

    const sectionOne = {
        heading: "",
        description: "",
        services: [],
        image: ""
    }
    const [sectionOneData, setSectionOneData] = useState(sectionOne);
    const [imageFile, setimageFile] = useState(null);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [section1Data, setSection1Data] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [sectionID, setSectionId] = useState("")

    // Toggle Modal
    const toggleModal = () => setModalOpen(!modalOpen);

    // Handle View Details
    const handleViewDetails = () => {
        toggleModal();
    }


    // Handle Edit
    const handleEdit = () => {
        setIsEdit(true)
        setSectionOneData({
            heading: section1Data?.heading || '',
            description: section1Data?.description || '',
            services: section1Data?.services || [],
            image: section1Data?.image || ''
        });
        setimageFile(section1Data?.image || null);
        setSelectedOptions(section1Data?.services?.map(service => ({ value: service, label: service })) || []);
    };

    // >>>>Handle Section One Input Change<<<<
    const handleSectionOneChange = (e) => {
        const { name, value } = e.target;
        setSectionOneData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // >>>>Handle Selected Options for Section 1<<<<
    const handleChange = (options) => {
        setSelectedOptions(options);
        setSectionOneData((prev) => ({
            ...prev,
            services: options.map(option => option.value)
        }));
    };

    // >>>>Handle Image<<<<
    const handleImage = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size must be less than 5 MB");
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        setLoading(true)
        const res = await HttpClient.fileUplode("image-upload", "POST", formData);
        if (res && res.status) {
            setLoading(false)
            toast.success("Image Uploaded Successfully");
            setimageFile(res?.url);
            setSectionOneData({ ...sectionOneData, image: res?.url })
        } else {
            setLoading(false)
            setimageFile(null)
            toast.error(res?.message || "Something Wrong");
        }
    };

    // >>>Handle Removing Image<<< 
    const handleRemoveImage = () => {
        setimageFile(null);
        setSectionOneData({ ...sectionOneData, image: "" })
        document.getElementById("image").value = "";
    };

    // Fetch Section One Data
    const fetchSectionOneData = async () => {
        setLoading(true);
        const res = await HttpClient.requestData("home", "GET");
        if (res && res?.status) {
            setLoading(false);
            setSectionId(res?.data?._id)
            setSection1Data(res.data ? res?.data?.section1 : {});
        } else {
            setLoading(false);
            setSection1Data({});
        }
    }

    // >>>>Handle Submit Data<<<<
    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            section1: sectionOneData,
        }
        console.log("carrerData", data)
        // return
        setLoading(true)
        // const res = await HttpClient.requestData(`home/66e41cc192eb3cb936c78deb`, "PUT", data);

        const res = await HttpClient.requestData(`home/${sectionID}`, "PUT", data);
        if (res && res?.status) {
            setLoading(false)
            toast.success(res?.message || "Data added successfully.!");
            setSectionOneData(sectionOne)
            setSelectedOptions([])
            setimageFile(null)
            setIsEdit(false)
            document.getElementById("image").value = "";
            fetchSectionOneData()
        } else {
            setLoading(false)
            return toast.error(res?.message || "Something went wrong...!")
        }
    }

    useEffect(() => {
        fetchSectionOneData();
    }, []);
    return (
        <div className="d-flex justify-content-end">
            {loading && <Loader />}
            <div className="form-header mx-2">
                <section className="piechartsBox_area">
                    {/* Section 1 */}
                    {isEdit &&
                        <>
                            <form onSubmit={handleSubmit}>
                                <div className='p-2 mb-4' style={{ border: "1px solid #eee" }}>
                                    <h2>Update Our Experience</h2>
                                    <div className="form-group section" style={{ border: "1px solid #ccc" }}>
                                        <div className="form-group mb-3">
                                            <label htmlFor="heading2">Heading</label>
                                            <input type="text" id="heading2" name="heading" className="form-control" value={sectionOneData?.heading} onChange={handleSectionOneChange} />
                                        </div>
                                        <div className="form-group mb-3">
                                            <label htmlFor="description2">Description</label>
                                            <textarea id="description2" name="description" className="form-control" rows="3" value={sectionOneData?.description} onChange={handleSectionOneChange}></textarea>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label htmlFor="services2">Services</label>
                                            <ReactSelectCreatable
                                                isMulti
                                                value={selectedOptions}
                                                onChange={handleChange}
                                                placeholder="Type and press Enter to add"
                                                noOptionsMessage={() => "Type and press Enter to add"}
                                            />
                                        </div>

                                        <div className='d-flex'>
                                            <div className="form-group mb-3 w-50">
                                                <label htmlFor="image">Image</label>
                                                <input
                                                    type="file"
                                                    id="image"
                                                    name="image"
                                                    className="form-control"
                                                    accept="image/*"
                                                    onChange={handleImage}
                                                />
                                            </div>
                                            {imageFile && (
                                                <div className="mx-5 d-flex align-item-center justify-content-center">
                                                    <img
                                                        className="mt-3"
                                                        alt="not found"
                                                        width={"100px"}
                                                        height={"100px"}
                                                        src={imageFile}
                                                        style={{ border: "1px solid #000", borderRadius: "10px", boxShadow: "0 10px 10px rgba(0,0,0,0.5)" }}
                                                    />
                                                    <span className="mt-2"
                                                        style={{ fontSize: "20px", cursor: "pointer" }}
                                                        onClick={() => handleRemoveImage()}
                                                    >
                                                        <i className="fa-solid fa-square-xmark" style={{ color: "#b40822" }}></i>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex justify-content-center'>
                                    <button type='submit' className='btn btn-outline-success w-75'>Update</button>
                                </div>
                            </form>
                            <hr />
                        </>
                    }

                    {section1Data && !isEdit && (
                        <div className="mt-5">
                            <h3>Our Experience Data</h3>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Heading</th>
                                        <th>Description</th>
                                        <th>Services</th>
                                        <th>Image</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{section1Data?.heading || '-'}</td>
                                        <td>{section1Data?.description || '-'}</td>
                                        <td>{section1Data?.services?.map(ele => ele)?.join(', ') || '-'}</td>
                                        <td>
                                            {section1Data?.image ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={section1Data?.image}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>
                                            <FaEye
                                                style={{ cursor: "pointer", marginRight: "15px", color: "#007bff" }}
                                                onClick={handleViewDetails}
                                                title="View Details"
                                            />
                                            <FaEdit
                                                style={{ cursor: "pointer", color: "#28a745" }}
                                                onClick={handleEdit}
                                                title="Edit"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    )}

                    {/* Modal for Viewing Details */}
                    <Modal isOpen={modalOpen} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>Our Experience Details
                            <span style={{
                                marginLeft: "225px",
                                cursor: "pointer"
                            }} onClick={() => { toggleModal() }}><FaTimes className='' style={{ marginTop: "-20px" }} /></span>
                        </ModalHeader>
                        <ModalBody>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Field</th>
                                        <th>Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Heading</td>
                                        <td>{section1Data?.heading || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Description</td>
                                        <td>{section1Data?.description || '-'}</td>
                                    </tr>

                                    <tr>
                                        <td>Services</td>
                                        <td>{section1Data?.services?.map(ele => ele)?.join(', ') || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td>Image</td>
                                        <td>
                                            {section1Data?.image ? (
                                                <img
                                                    alt="Banner"
                                                    width={"100px"}
                                                    height={"100px"}
                                                    src={section1Data?.image}
                                                    style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                                />
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ModalBody>
                        <Button color="secondary" onClick={toggleModal}>Close</Button>
                    </Modal>
                </section>
            </div>
        </div>
    )
}

export default OurExperience